// src/mocks/handlers/filters/filtersCurrencies.tsx

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { ICustomerCurrencies } from '@/domains/filters/filters.types';
import currenciesData from '@/mocks/data/customerCurrencies.json';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const filterCurrenciesHandler = rest.get<ICustomerCurrencies>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.CUSTOMER_CURRENCIES}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const { customer_uuid } = req.params as { customer_uuid: string };

    // Mock response data
    const match = currenciesData.find((entry) => entry.uuid === customer_uuid);
    if (!match) {
      return res(
        ctx.status(404),
        ctx.json({ detail: 'Customer currencies not found' }),
      );
    }
    const mockResponse: ICustomerCurrencies = {
      currencies: match.currencies,
    };
    // Return the mock response
    return res(ctx.status(200), ctx.json(mockResponse));
  },
);
